module.exports = __webpack_public_path__ + "img/burger.1ea3f300.svg";